module.exports = __webpack_public_path__ + "static/media/1019456.1343bda3.jpg";